// extracted by mini-css-extract-plugin
module.exports = {"fullWidthBanner":"full-width-banner-module--full-width-banner--D_Igq","fullWidthBanner__image":"full-width-banner-module--full-width-banner__image--22l5H"};